import ButtonGroup from 'terra-button-group';
import styled from 'styled-components';

const GroupButtons = ({ items, onChange, selected = null }) => {
  const handleSelection = (event, selectedKey) => onChange(selectedKey);

  return (
    <ButtonGroup
      id="controlled-button-group"
      onChange={handleSelection}
      selectedKeys={[selected]}
    >
      {items.map(item => (
        <ButtonItem text={item.label} key={item.value} />
      ))}
    </ButtonGroup>
  );
};

const ButtonItem = styled(ButtonGroup.Button)`
  background: #F4F4F4;
  border-color: #E0E0E0;
  color: #4F4F4F;
  font-size: 12px;
  font-weight: 500;

  &[aria-checked="true"] {
    background-color: #E8F4EE;
    color: #2B583F;
    border: 1px solid #519A71;
    border-radius: 4px;
    margin-right: 1px;
  }
`;

export default GroupButtons;
